import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { IncentivesEntities } from 'client/data/models/incentives';
import { formatPriceString } from 'client/site-modules/shared/utils/price-utils';
import { INCENTIVE_HEAD_TITLES } from 'site-modules/shared/constants/incentives';

export function IncentiveRebateInfo({ incentive = {}, titleType, isLast = false }) {
  const { startDate, endDate, rebateAmount, percentOffMSRP } = incentive;
  const titles = get(INCENTIVE_HEAD_TITLES, titleType, []);
  const usePercent = !!percentOffMSRP && !rebateAmount;

  return (
    <Fragment>
      <Row tag="dl" noGutters className="mb-0">
        <Col xs={12} md={3}>
          <dt className="fw-medium">{usePercent && titles[0] ? titles[0].replace('$', '%') : titles[0]}</dt>
          <dd className="fw-bold">
            {usePercent ? `${percentOffMSRP}%` : rebateAmount && formatPriceString(rebateAmount)}
          </dd>
        </Col>
        <Col xs={6} md={{ size: 3, offset: 3 }}>
          <dt className="fw-medium">{titles[1]}</dt>
          <dd>{startDate}</dd>
        </Col>
        <Col xs={6} md={3}>
          <dt className="fw-medium">{titles[2]}</dt>
          <dd>{endDate}</dd>
        </Col>
      </Row>
      {!isLast && <hr />}
    </Fragment>
  );
}

IncentiveRebateInfo.propTypes = {
  incentive: IncentivesEntities.IncentivesGraphql,
  titleType: PropTypes.string.isRequired,
  isLast: PropTypes.bool,
};
